import { createSelector } from 'reselect';

import { Favorite } from 'types';

const getFavorite = (favorites: Favorite[], favoriteId: string) => favorites.find(favorite => favorite.id === favoriteId);
export const makeGetFavorite = () => createSelector(getFavorite, favorites => favorites);

const getFavorites = (favorites: Favorite[]) => favorites
    .filter(favorite => favorite && !favorite.removed)
    .sort((favoriteA, favoriteB) => favoriteA.order - favoriteB.order);

export const makeGetFavorites = () => createSelector(getFavorites, favorites => favorites);

const getFavoriteByTypeProjectAndResource = (favorites: Favorite[], type: Favorite['type'], projectId?: Favorite['project_id'], resourceId?: Favorite['resource_id']) => favorites
    .find(favorite => favorite && !favorite.removed && favorite.type === type && (!resourceId || favorite.resource_id === resourceId) && (!projectId || favorite.project_id === projectId));

export const makeGetFavoriteByTypeProjectAndResource = () => createSelector(getFavoriteByTypeProjectAndResource, favorites => favorites);
